import { COUNTRY, HrefLangListType, BRAND_LIST } from "@type/index";
import { findStrIndex } from "@util/helpers";

export const getHrefLangList = (
  region: string,
  endPath: string,
  brand: string
): HrefLangListType[] => {
  const _index = findStrIndex(endPath, "/", 2);
  const _path = endPath.slice(_index + 1);
  let hrefLang: HrefLangListType[] = [];
  switch (region) {
    case COUNTRY.HK:
      if (brand === BRAND_LIST.UQ) {
        hrefLang = [
          {
            hrefLang: "zh-HK",
            alternateHref: ["hk", "zh_HK", _path].join("/")
          },
          { hrefLang: "en-GB", alternateHref: ["hk", "en_GB", _path].join("/") }
        ];
      } else {
        hrefLang = [
          { hrefLang: "zh-HK", alternateHref: ["hk", "zh_HK", _path].join("/") }
        ];
      }
      break;
    case COUNTRY.TW:
      hrefLang = [
        { hrefLang: "zh-TW", alternateHref: ["tw", "zh_TW", _path].join("/") }
      ];
      break;
    default:
      break;
  }
  return hrefLang;
};
